

/** 
 * =============================== 运营平台 投放标识 ===============================
 * 
 *  接口: https://api-edu.wps.cn/operation-api/official/image/text/query?
 *  参数: pos: [必填] 投放位置标识, 产品运营配置唯一标识
 *        pageNum: 页码, 默认值: 1
 *        pageSize: 每页条数, 默认值: 10
 */

// ------ K12人工智能教学页 ------
// 客户案例
export const SOLUTION_K12_CASE = 'official_website_solution_k12_case';

// ------ 高校人才培养页 ------
// 客户案例
export const SOLUTION_COLLEGE_CASE = 'official_website_solution_higher_education_case';
// 客户声音
export const SOLUTION_COLLEGE_VOICE = 'official_website_solution_higher_education_voice';



/** 
 * =============================== 策略平台 投放标识 ===============================
 *  简介: 这个是365的系统策略配置后台，我们后台不能满足的就用这个来处理了
 *  接口: https://plus.wps.cn/ops/opsd/api/v1/policy?
 *  参数: window_key: [必填] 投放标识, 产品运营配置唯一标识
 *        utm_source: [必填] 来源, (默认值: WPS365_EDU_WEB)
*/

// 首页 - WPS智慧教育平台 - 筑强育人根基 聚力人才培养
export const EDU_WPS_OFFICE_SMART_PERSONNEL_TRAINING = 'edu_wps_office_smart_personneltraining';
